var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, PacemEventTarget, Watch, PropertyConverters, Utils } from './_default-imports';
//namespace Pacem.Components {
function base64ToUint8Array(base64) {
    const padding = '='.repeat((4 - base64.length % 4) % 4);
    base64 = (base64 + /*ensure correct length*/ padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');
    const rawData = window.atob(base64);
    const output = new Uint8Array(rawData.length);
    for (var i = 0; i < rawData.length; i++) {
        output[i] = rawData.charCodeAt(i);
    }
    return output;
}
let PacemServiceWorkerProxyElement = class PacemServiceWorkerProxyElement extends PacemEventTarget {
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._tryRegister();
    }
    disconnectedCallback() {
        this._tryUnregister();
        super.disconnectedCallback();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'pushSubscription':
                if (!Utils.isNull(old)) {
                    this.dispatchEvent(new CustomEvent('unsubscribe', { detail: old }));
                }
                if (!Utils.isNull(val)) {
                    this.dispatchEvent(new CustomEvent('subscribe', { detail: val }));
                }
                break;
            case 'registration':
                if (!Utils.isNull(old)) {
                    this.dispatchEvent(new CustomEvent('unregister', { detail: old }));
                }
                if (!Utils.isNull(val)) {
                    this.dispatchEvent(new CustomEvent('register', { detail: val }));
                }
                break;
        }
    }
    _tryUnregister(reg = this.registration) {
        if (!Utils.isNull(reg)) {
            return reg.unregister();
        }
        return Promise.resolve(true);
    }
    _tryRegister(src = this.src) {
        this._tryUnregister().then(_ => {
            // register new sw
            if (!Utils.isNullOrEmpty(src) && 'serviceWorker' in navigator) {
                navigator.serviceWorker.register(src)
                    .then(reg => {
                    this.registration = reg;
                    if ('PushManager' in window) {
                        reg.pushManager.getSubscription().then(sub => {
                            this.pushSubscription = sub;
                        });
                    }
                });
            }
        });
    }
    unsubscribe(subscription = this.pushSubscription) {
        return new Promise((resolve, reject) => {
            if (!Utils.isNull(subscription)) {
                const refresh = subscription === this.pushSubscription;
                subscription.unsubscribe().then(result => {
                    if (refresh) {
                        // triggers 'unsubscribe' event
                        this.pushSubscription = null;
                    }
                    resolve(result);
                });
            }
            else {
                resolve(false);
            }
        });
    }
    subscribe(publicKey = this.publicKey) {
        return new Promise((resolve, reject) => {
            if (typeof publicKey === 'string') {
                publicKey = base64ToUint8Array(publicKey);
            }
            const push = this.registration?.pushManager;
            if (!Utils.isNull(push)) {
                push.subscribe({
                    userVisibleOnly: true,
                    applicationServerKey: publicKey
                }).then(subscription => {
                    if (Notification.permission === 'denied') {
                        resolve(this.pushSubscription = null);
                    }
                    else {
                        resolve(/* triggers 'subscribe' event */ this.pushSubscription = subscription);
                    }
                });
            }
            else {
                // no PushManager available
                resolve(null);
            }
        });
    }
};
__decorate([
    Watch()
], PacemServiceWorkerProxyElement.prototype, "registration", void 0);
__decorate([
    Watch()
], PacemServiceWorkerProxyElement.prototype, "pushSubscription", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemServiceWorkerProxyElement.prototype, "src", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemServiceWorkerProxyElement.prototype, "publicKey", void 0);
PacemServiceWorkerProxyElement = __decorate([
    CustomElement({ tagName: P + '-serviceworker-proxy' })
], PacemServiceWorkerProxyElement);
export { PacemServiceWorkerProxyElement };
//}
